import styled from "styled-components";

const DetailsList = styled.div`
	display: flex;
	flex-direction: column;
`

export default DetailsList